import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId"];
import { Select } from 'foundations-components/transitional/components/Select';
import { useUsersForAccount } from '../accountsQueries';
import formatName from 'I18n/utils/formatName';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const generateOptions = usersForAccount => {
  return usersForAccount ? usersForAccount.users.map(user => ({
    text: formatName({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email
    }),
    value: user.id
  })) : [];
};
export const AccountUsersSelect = _ref => {
  let {
      accountId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    usersForAccount,
    usersForAccountLoading
  } = useUsersForAccount({
    accountId
  });
  const options = useMemo(() => generateOptions(usersForAccount), [usersForAccount]);
  return /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
    isLoading: usersForAccountLoading,
    multi: true,
    options: options
  }));
};